"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const molecules_1 = require("../../molecules");
const SecondaryLayout = ({ children, isAuthenticated, logo, logoutTitle, onLogout, avatar, userTitle, additionalNavContent, footer, }) => {
    return (react_1.default.createElement("div", { className: "flex flex-col w-full min-h-screen dark:bg-black-800 bg-gray-100" },
        react_1.default.createElement(molecules_1.NavBarHorizontal, { avatar: avatar, isAuthenticated: isAuthenticated, logo: logo, logoutTitle: logoutTitle, onLogout: onLogout, userTitle: userTitle }, additionalNavContent),
        react_1.default.createElement("div", { className: 'max-w-screen-lg p-3 mx-auto' }, children),
        footer));
};
exports.default = SecondaryLayout;
